import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  SimpleGrid,
  VStack,
  HStack,
  Avatar,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { useAppData } from '../../store/dataStore';

const MotionBox = motion(Box);

const WebinarSocialProof = ({ data }) => {
  const { appData } = useAppData();
  const { webinarAttendedCount } = appData;

  // Safety check
  const componentData = data || {
    title: 'What Past Attendees Say',
    testimonials: []
  };

  return (
    <Box py={{ base: 16, md: 24 }} bg="brand.50">
      <Container maxW="container.xl">
        <MotionBox
          textAlign="center"
          mb={12}
          initial={{ y: 20, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <Text
            fontSize={{ base: 'xl', md: '2xl' }}
            fontWeight="700"
            color="accent.green"
            mb={4}
          >
            Join {webinarAttendedCount}+ who've attended
          </Text>
          <Heading
            as="h2"
            fontSize={{ base: '2xl', md: '4xl' }}
            color="brand.700"
            fontFamily="heading"
          >
            {componentData.title}
          </Heading>
        </MotionBox>

        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={8}>
          {componentData.testimonials.map((testimonial, index) => (
            <MotionBox
              key={index}
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
            >
              <Box
                bg="white"
                p={8}
                borderRadius="xl"
                boxShadow="md"
                h="full"
                _hover={{ boxShadow: 'xl', transform: 'translateY(-4px)' }}
                transition="all 0.3s"
              >
                <VStack align="start" spacing={4}>
                  <Text
                    fontSize="md"
                    color="brand.600"
                    fontStyle="italic"
                  >
                    "{testimonial.text}"
                  </Text>
                  <HStack>
                    <Avatar
                      size="sm"
                      name={testimonial.name}
                      bg="accent.green"
                    />
                    <VStack align="start" spacing={0}>
                      <Text fontWeight="600" fontSize="sm" color="brand.700">
                        {testimonial.name}
                      </Text>
                      <Text fontSize="xs" color="brand.500">
                        {testimonial.role}
                      </Text>
                    </VStack>
                  </HStack>
                </VStack>
              </Box>
            </MotionBox>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
};

export default WebinarSocialProof;